import { t } from "i18next";
import * as yup from "yup";

import { SharingScheduleRules } from "../../constants";

export const sharingScheduleValidationSchema = yup.object({
  id: yup.string().nullable(),
  name: yup
    .string()
    .required(t("Name is required"))
    .min(3, t("Name must be at least 3 characters long"))
    .max(100, t("Name must be at most 100 characters long")),
  dateRange: yup.array().of(yup.date()).required(t("Date range is required")),
  numberOfProducts: yup.number().required(),
  rule: yup.string().required(),
  ruleTimeframe: yup
    .string()
    .nullable()
    .when("rule", {
      is: (rule: SharingScheduleRules) =>
        rule !== SharingScheduleRules.ManualSelectionOfProducts,
      then: () => yup.string().required(t("Rule's timeframe is required"))
    }),
  productVariants: yup.array().of(yup.object()).required()
});
